import { render, staticRenderFns } from "./OutOfStockPopup.vue?vue&type=template&id=2835f37c&scoped=true&"
import script from "./OutOfStockPopup.vue?vue&type=script&lang=js&"
export * from "./OutOfStockPopup.vue?vue&type=script&lang=js&"
import style0 from "./OutOfStockPopup.vue?vue&type=style&index=0&id=2835f37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835f37c",
  null
  
)

export default component.exports